import { h } from 'vue'
import { Icon } from '@iconify/vue'
import AuditStatusLabel from './AuditStatusLabel.vue'
import EllipsisText from './EllipsisText.vue'
import Empty from './Empty.vue'
import IdLabel from './IdLabel.vue'
import TaskStatus from './TaskStatus.vue'
import VideoActionBar from './VideoActionBar.vue'
import VideoDurationLabel from './VideoDurationLabel.vue'
import VideoPreview from './VideoPreview.vue'
import ImagePreview from './ImagePreview.vue'
import CoverRatioWrap from './CoverRatioWrap.vue'
import BaseNav from './BaseNav.vue'
import BaseDialog from './BaseDialog.vue'
import SearchInput from './search-input.vue'
import BackTitle from './BackTitle.vue'

export const atomsComponents = {
  AuditStatusLabel,
  EllipsisText,
  Empty,
  IdLabel,
  TaskStatus,
  VideoActionBar,
  VideoDurationLabel,
  VideoPreview,
  ImagePreview,
  CoverRatioWrap,
  BaseNav,
  BaseDialog,
  SearchInput,
  BackTitle,
}

export const LoadingIcon = h(Icon, { icon: 'sky:ic-loading', class: 'size-4' })
